import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "PaymentMethodList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      search_status: false,
      payment_method: "",
      description: "",
      paymentMethodMasterData: {},
      searchedData: null,
      isSearched: false
    };
  },

  methods: {
    reset() {
      this.payment_method = '';
      this.isLoading = true;
      this.getAllPaymentMethod();
      this.isSearched = false;
    },

    searchPaymentMethod(page = 1) {
      this.isLoading = true;
      this.searchedData = { payment_method: this.payment_method };
      this.isSearched = true;
      axios.get('paymentMethod/search?page=' + page, {
        params: {
          payment_method: this.payment_method,
        }
      })
        .then(res => {
          if (res.data) {
            this.paymentMethodMasterData = res.data;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getAllPaymentMethod(page = 1) {
      axios.get('paymentMethod/list?page=' + page)
        .then((response) => {
          this.paymentMethodMasterData = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    showCreate() {
      this.$router.push({
        path: "/paymentMethod/create"
      });
    },

    showEdit(id) {
      this.$router.push({
        name: "paymentMethodEdit",
        params: {
          id: id
        }
      });
    },

    showDetail(id) {
      this.$router.push({
        name: "paymentMethodDetail",
        params: {
          id: id
        }
      });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deletePaymentMethod(id);
      } else {
        console.log("no");
      }
    },

    deletePaymentMethod(id) {
      this.isLoading = true;
      axios.delete("/paymentMethod/delete/" + id)
        .then(response => {
          if (response.data.success == true) {
            this.getAllPaymentMethod();
            this.$notification.success('Payment Method Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          } else {
            this.$notification.error("Payment Method data is already deleted.", {
              timer: 3,
              position: "bottomCenter"
            });
            this.getAllPaymentMethod();
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Payment Method Delete Error->", error.response.data);
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : {};
      axios.get('/paymentMethod/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `payment_method_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getAllPaymentMethod();
  },
};
